import styles from './Element.module.scss';

export const Element = ({clickHandler, children}) => {
    const handlerClick = (e) => {
        e.currentTarget.parentElement.classList.add(styles.rotate);
        clickHandler();
    }

    return (
        <div className={styles.card}>
            <div className={styles.front}>{children}</div>
            <div className={styles.back} onClick={e => handlerClick(e)}/>
        </div>
    )
}